import React from "react";

import { CommentDotsRegularV6 } from "@shared/v2/Icomoon";

import ActivityContainer from "./ActivityContainer";
import { activityCommonDefaultProps, activityCommonPropTypes, STYLES } from "../shared";
import Header from "./Header";
import CategoryContainer from "./CategoryContainer";

const TextActivity = ({ activity, onReadChange }) => {
  const queryParams = new URLSearchParams();
  queryParams.set("tab", "3");

  return (
    <ActivityContainer activity={activity} queryParams={queryParams.toString()} onReadChange={onReadChange}>
      <Header
        category={
          <CategoryContainer
            containerClassName="tw-bg-[#FAF1E6] tw-text-[#AD6714]"
            Icon={CommentDotsRegularV6}
          >
            New Message
          </CategoryContainer>
        }
        personName={`${activity.data.subjectFirstName} ${activity.data.subjectLastName}`}
        time={activity.createdAt}
        onReadChange={onReadChange}
        loading={activity.loading}
        read={activity.read}
      />
      <span className={`${STYLES.lineClamp3} tw-px-8px`}>{activity.data.messageText}</span>
    </ActivityContainer>
  );
};

export default TextActivity;

TextActivity.propTypes = {
  ...activityCommonPropTypes,
};

TextActivity.defaultProps = {
  ...activityCommonDefaultProps,
};
